export const hasAcceptedLatestTerms = (
  latestVersion: number,
  arrAcceptedTerms: any
) => !!arrAcceptedTerms.find(x => x.termsId === latestVersion);
